import { SearchParameter, BaseModel } from './base.model';
import { BusinessPlan } from './business-plan.model';

export class SchoolCapacity {
  id: string;
  year: number;
  availableUsersAmount: number | undefined;
  type: number;
  studentEnrollmentPermit: boolean | null;
}

export class School extends BaseModel {
  id: string;
  name: string;
  studentEnrollmentPermit: boolean | null;
  courseIdList?: Array<string>;
  type: string;
  consultantIdList?: Array<string>;
  capacityList?: Array<SchoolCapacity>;
  staffCapacityList?: Array<SchoolCapacity>;
  businessPlan?: BusinessPlan;
  testGradeReleaseType?: number;
}

export class SchoolSearchParameter extends SearchParameter {
  limit?: number;
  name?: string;
  type?: string;
  idList?: any;
  consultantIdList?: Array<string>;
  haveSasId?: boolean;
}
